<template>
  <div class="mt-4">
    <label for="donor-name" class="donor-name">{{ label }}</label>
    <input class="form__text" type="text" id="donor-name" v-model="name" :placeholder="placeholder" />
    <span class="small remark">* ผู้บริจาคสามารถนำเงินบริจาคไปหักลดหย่อนภาษีได้ 2 เท่า </span>
  </div>
</template>

<script>
export default {
  name: 'DonorInfo',

  props: {
    value: { type: String },
    label: { type: String, default: 'ชื่อผู้บริจาค' },
    placeholder: { type: String, default: 'เว้นว่างไว้ หากไม่ประสงค์ออกนาม' }
  },

  data () {
    return {
      name: ''
    }
  },

  watch: {
    name: function (newValue, oldValue) {
      this.$emit('input', this.name)
      this.$forceUpdate()
    }
  }
}
</script>

<style scoped lang="scss">
.donor-name  {
  font-family: 'Wittaya-Medium';
  font-size: 1.1rem;
}
.remark { font-family: 'Wittaya-Medium'; }
</style>



// WEBPACK FOOTER //
// DonorInfo.vue?bb5ad27a